import { isVideoAddition } from '../../common/helpers';
import { CanvasApiBaseResponse } from '../../common/requestsTypings';
import { SharedData } from '../../common/typings';
import { CanvasApiMethodExecutor } from '../CanvasApiMethodExecutor';

export interface Preset {
    id: number;
    name: string;
    thumbnail: string;
    items?: {
        width: number;
        height: number;
        options: {
            isAdaptive: boolean;
        };
    }[];
}

export interface PresetsApiResponse extends CanvasApiBaseResponse {
    items: Preset[];
    total: number;
}

export class PresetsMethodExecutor extends CanvasApiMethodExecutor {
    async get(sharedData: SharedData): Promise<PresetsApiResponse> {
        let path = 'presets';
        if (isVideoAddition(sharedData.creativeType)) {
            path = 'video/presets';
        }
        const params = {
            method: 'GET'
        };

        return this.createRequest(path, params, sharedData);
    }
}
